import { useMemo, useSyncExternalStore } from "react";
import { CUSTOM_PERIOD, presetRange } from "./periods";

// One period for every place of the application that opens Resource Insights outside the planner, so it is kept when
// the panel is closed and opened again for someone else. The planner has its own period and does not use this one.
let state = { preset: "this_month", custom: null };
const listeners = new Set();

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getState = () => state;

function setState(next) {
  state = next;
  listeners.forEach((listener) => listener());
}

/** The dates of a period: a usual period around today, or the range the user typed in. */
const rangeOf = ({ preset, custom }) => (preset === CUSTOM_PERIOD && custom ? custom : presetRange(preset));

/**
 * The period shared by the places that open Resource Insights outside the planner: which period is chosen, the dates
 * it covers (`range`, yyyy-MM-dd), and how to change it.
 */
export function useInsightsPeriod() {
  const current = useSyncExternalStore(subscribe, getState);

  return useMemo(
    () => ({
      preset: current.preset,
      range: rangeOf(current),
      // A usual period is picked by name; picking the custom range starts it from the dates in use.
      setPreset: (preset) => {
        const before = getState();
        setState({ preset, custom: preset === CUSTOM_PERIOD ? before.custom ?? rangeOf(before) : before.custom });
      },
      // The dates the user typed in, which become the period.
      setCustom: (range) => setState({ preset: CUSTOM_PERIOD, custom: { startDate: range.startDate, endDate: range.endDate } }),
    }),
    [current]
  );
}
